module.exports = __webpack_public_path__ + "media/images/ScreenLetterFindMoreInfo-b0a3a0e76c7c46335872cc6916b48f82.jpg";